import { render, staticRenderFns } from "./Tokens.vue?vue&type=template&id=74878888"
import script from "./Tokens.vue?vue&type=script&lang=js"
export * from "./Tokens.vue?vue&type=script&lang=js"
import style0 from "./Tokens.vue?vue&type=style&index=0&id=74878888&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports